function RentController($document) {
	'ngInject';

	const vm = this;

	vm.scrollToSection = scrollToSection;

	init();

	/** */
	function init() {
		$document.scrollTo(angular.element(document.getElementById('rentContainer')), 200, 100);
	}

	/** */
	function scrollToSection(sectionId) {
		const section = angular.element(document.getElementById(sectionId));

		$document.scrollToElement(section, 80, 300);
	}
}

export default RentController;



/** WEBPACK FOOTER **
 ** ./client/public/main/rent/rent.controller.js
 **/